import React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

import { Pattern, PatternProps } from '@/components/ui/pattern'

const widgetVariants = cva(
  'flex w-full flex-col gap-6 rounded-lg border border-green-200 p-6 relative overflow-hidden',
  {
    variants: {
      variant: {
        green: 'border-green-100 bg-green-50/50',
        blue: 'border-blue-100 bg-blue-50/50',
        yellow: 'border-yellow-200/80 bg-yellow-50/50',
      },
    },
  },
)

export interface WidgetProps
  extends React.ComponentPropsWithoutRef<'div'>,
    VariantProps<typeof widgetVariants> {
  icon: React.ReactNode
  heading: string
  description: string
  background?: PatternProps['variant']
}

export const Widget = ({
  className,
  variant,
  background,
  icon,
  heading,
  description,
}: WidgetProps) => {
  return (
    <div
      className={cn(
        widgetVariants({
          variant,
          className,
        }),
      )}
    >
      {icon}

      <div className="flex flex-col gap-0.5">
        <h2 className="font-mono text-xl font-medium">{heading}</h2>
        <span className="text-sm font-medium text-gray-950">{description}</span>
      </div>
      <Pattern
        variant={background}
        className={cn(
          'absolute bottom-[-50px] right-[-50px] size-[200px] opacity-30',
          {
            'text-green-300': variant === 'green',
            'text-blue-300': variant === 'blue',
            'text-yellow-500': variant === 'yellow',
          },
        )}
      />
    </div>
  )
}
